import React, { useEffect } from 'react';
import LandingFooter from '../../components/layouts/LandingFooter';
import AOS from 'aos';
import 'aos/dist/aos.css';

const TermsConditions: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, delay: 300 });
  }, []);

  return (
    <>
      <div className="d-flex flex-column bg-base-gradient flex-center w-100 min-h-200px z-index-n1 min-h-lg-350px px-9">
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
            <div className="mb-lg-10 pt-10 py-lg-5">
              <h1 className="text-base-dark lh-base fw-bold fs-1x fs-lg-3x mb-5 text-uppercase" data-aos="fade-up">
                Terms & Conditions
              </h1>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-n10 mt-lg-n10 z-index-2 min-h-300px inner-box">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 mx-auto shadow bg-white px-15 mb-15 inner-content">
              <div className="fs-5 mt-15" data-aos="fade-up">
                <p>
                  Please read these Terms and Conditions carefully before using the Fesilah application ("the Application") provided by Fesilah LLC ("the Company"), an LLC registered in the United Arab Emirates (UAE) and founded in 2022. These Terms and Conditions govern your access to and use of the Application for agricultural consulting services. By accessing or using the Application, you agree to be bound by these Terms and Conditions.
                </p>
                <br />
                <h4>1. Use of the Application:</h4>

                <h5>1.1 Eligibility:</h5>
                <p className="fs-5">By using the Application, you represent that you are at least 18 years old and have the legal capacity to enter into a binding agreement with the Company. If you are using the Application on behalf of an organization, you represent that you have the authority to bind the organization to these Terms and Conditions.</p>

                <h5>1.2 License:</h5>
                <p className="fs-5">Subject to your compliance with these Terms and Conditions, the Company grants you a limited, non-exclusive, non-transferable, and revocable license to access and use the Application solely for the purpose of availing agricultural consulting services provided by the Company. </p>

                <h5>1.3 User Account:</h5>
                <p className="fs-5">In order to access certain features or services within the Application, you may be required to create a user account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account. You agree to provide accurate and complete information when creating your account and to promptly update any changes.</p>
                
                <h4>2. Intellectual Property:</h4>

                <p className="fs-5">The Application and its contents, including but not limited to text, graphics, logos, trademarks, and software, are the intellectual property of the Company or its licensors and are protected by applicable copyright, trademark, and other intellectual property laws. You may not modify, reproduce, distribute, display, or create derivative works based on any part of the Application without the prior written consent of the Company. </p>

                <h4>3. User Responsibilities:</h4>

                <h5>3.1 Prohibited Conduct:</h5>
                <p className="fs-5">When using the Application, you agree not to:
                  <br />- Violate any applicable laws, regulations, or third-party rights
                  <br />- Engage in fraudulent, deceptive, or unlawful activities
                  <br />- Upload or transmit any viruses, malware, or harmful content
                  <br />- Interfere with the operation or security of the Application or its servers
                  <br />- Use automated scripts or bots to access or interact with the Application
                  <br />- Attempt to gain unauthorized access to any part of the Application</p>
                
                <h5>3.2 Content Submission:</h5>
                <p className="fs-5">If you submit any content, including but not limited to comments, suggestions, or feedback, to the Company through the Application, you grant the Company a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, adapt, publish, and display the content for the purpose of providing and improving the Application and related services.</p>

                <h4>4. Limitation of Liability: </h4>

                <p className="fs-5"> To the fullest extent permitted by law, the Company shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of or in connection with your use of the Application. This limitation of liability applies regardless of the legal theory under which such damages are sought, and even if the Company has been advised of the possibility of such damages.
                </p>
                <h4>5. Indemnification: </h4>

                <p className="fs-5"> You agree to indemnify and hold harmless the Company, its officers, directors, employees, and agents from any claims, liabilities, damages, losses, costs, or expenses (including reasonable attorneys' fees) arising out of or in connection with your use of the Application, your violation of these Terms and Conditions, or your violation of any applicable laws or third-party rights.
                </p>
                <h4>6. Termination:</h4>

                <p className="fs-5"> The Company reserves the right to suspend or terminate your access to the Application at any time, without prior notice and for any reason. Upon termination, the provisions of these Terms and Conditions that by their nature should survive, including but not
                </p>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default TermsConditions;
